module.exports = __webpack_public_path__ + "img/Upscaler01.2088a8ca.png";